"use client";
import { j as e } from "./index.es44.js";
import { forwardRef as n, useMemo as h } from "react";
import { makeUniqueId as m } from "./index.es126.js";
n(
  ({ label: o, isChecked: d, onChange: r, isDefaultChecked: a, isDisabled: c, inputId: s, ...l }, t) => {
    const i = h(() => m(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-checkbox", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: t,
          onChange: r,
          type: "checkbox",
          id: s || i,
          defaultChecked: a,
          disabled: c,
          checked: d
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: s || i, children: o })
    ] });
  }
);
//# sourceMappingURL=index.es46.js.map
